import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { translate } from 'react-i18next';
import { ReduxAsyncConnect, asyncConnect, reducer as reduxAsyncConnect } from 'redux-connect';
import { CreateUserForm } from 'components';
import * as userActions from 'redux/modules/users';
import * as ficheActions from 'redux/modules/fiches';
import { isLoaded as areGroupsLoaded, load as loadGroups } from 'redux/modules/groups';
import { isLoaded as areUsersLoaded, load as loadUsers } from 'redux/modules/users';

@translate(['common'])
@asyncConnect([{
  promise: ({ store: { dispatch, getState }, params }) => {
    const promises = [];
    promises.push(dispatch(loadGroups(params)));
    promises.push(dispatch(loadUsers(params)));
    promises.push(dispatch(ficheActions.load(0, params)));
    return Promise.all(promises);
  }
}])
@connect(
  state => ({
    user: state.auth.user,
  })
)
export default class AddUser extends Component {
  render() {
    const {
      t,
      user,
      groups
    } = this.props;

    const styles = require('./AddUser.scss');
    var c_id;
    if (user.role == 'admin') {
      c_id = this.props.params.id
    } else if (user.role.indexOf('client') > -1) {
      c_id = user.id
    } else if (user.role.indexOf('user') > -1) {
      c_id = user.c_id
    }

    return (
      <div className={styles.loginPage + ' container'}>
        <Helmet title={t("main.create_user")} />
        <h1>{t("main.create_user")}</h1>

        <CreateUserForm
          urlParams={this.props.params}
          formKey="createUserForm1"
          initialValues={{ user: { c_id: c_id } }} c_id={c_id}
          user_info={this.props.user} />
      </div>
    );
  }
}
